import axios from "axios";
import { useAuthStore, useErrorStore } from "@/store";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

instance.interceptors.request.use(
  async (config) => {
    const authStore = useAuthStore();
    if (authStore.tokens.access.expires < new Date().toISOString()) {
      await authStore.refreshToken();
    }
    if (authStore.tokens.access.token) {
      config.headers[
        "Authorization"
      ] = `Bearer ${authStore.tokens.access.token} `;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    console.log(err);
    if (err.response.status == 401 || err.response.status == 403) {
      const authStore = useAuthStore();
      const errorStore = useErrorStore();

      errorStore.open = true;
      errorStore.message =
        "Unauthorized, or session expired. Please try logging in again.";
      errorStore.retry = false;
      authStore.logout();
    }
    if (
      err.response.status == 500 ||
      err.response.status == 501 ||
      err.response.status == 502
    ) {
      const errorStore = useErrorStore();

      errorStore.open = true;
    }

    return Promise.reject(err);
  }
);

export default instance;
